import { Link } from "@tanstack/react-router";
import { trackWeightLossCtaClick } from "@/lib/analytics";

/**
 * Shared CTA pair linking to the two weight-loss category hubs.
 * Used on the homepage and at the bottom of every service / medication page,
 * so label or destination changes propagate site-wide.
 *
 * Clicks emit a GA4 `weight_loss_cta_click` event with the category,
 * placement, and originating page path so conversion can be measured per page.
 */
export function WeightLossOptionsButtons({
  className = "",
  location = "cta_pair",
}: {
  className?: string;
  location?: string;
}) {
  return (
    <>
      <Link
        to="/medical-weight-loss"
        onClick={() => trackWeightLossCtaClick("medical", "/medical-weight-loss", location)}
        data-analytics-id="cta-medical-weight-loss"
        className={`w-full max-w-[17rem] sm:w-auto sm:max-w-none rounded-full bg-brand-logo px-7 py-3 text-sm font-medium text-brand-foreground hover:opacity-90 text-center ${className}`}
      >
        Medical Weight Loss
      </Link>
      <Link
        to="/services"
        onClick={() => trackWeightLossCtaClick("surgical", "/services", location)}
        data-analytics-id="cta-bariatric-surgery"
        className={`w-full max-w-[17rem] sm:w-auto sm:max-w-none rounded-full bg-brand-logo px-7 py-3 text-sm font-medium text-brand-foreground hover:opacity-90 text-center ${className}`}
      >
        Bariatric Surgery
      </Link>
    </>
  );
}
